<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col xs="12" class="pa-2">
                

                    <v-card>
                        <v-toolbar dense >
                  <span style="width: 270px;" class="ml-4">
                       <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="300px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="from_date +' - '+to_date"
                            label="Date range"
                            prepend-icon="mdi-calendar"
                              dense
                              solo
                              hide-details
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="from_date" no-title scrollable class="mr-1">  </v-date-picker>
                         <v-date-picker v-model="to_date" no-title scrollable @input="getItems(),menu = false">  </v-date-picker>
                      </v-menu>
                  </span>
                   <span style="width: 290px;" class="ml-2">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            solo
                            dense
                            hide-details
                        ></v-text-field>
                        </span>
                          <v-spacer/>
                         <v-btn small text color="success" @click="salesform=true"><v-icon left >mdi-plus-box</v-icon> Add A.R.</v-btn>
                        </v-toolbar>
                             <v-data-table
                                class="va-table mt-3"
                                :headers="headers"
                                :search="search"
                                :items="receivables"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                            <td>{{item.invoice}}</td>
                                            <td>{{item.drnumber}}</td>
                                            <td>{{item.trade_name}}</td>
                                            <td>{{item.salesman}}</td>
                                            <td>{{item.invoice_date | moment($date_format)}}</td>
                                            <td class="text-right">{{ $money(item.amount) }}</td>
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
                    </v-card>
            </v-col>
    </v-row>
     <va-sales-form-update :show="salesform"  @DialogEvent="salesEvent" />
  
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        salesform: false,
        form: false,
        menu:false,
        confirm: false,
        state: 'new',
        po: {},
        search:'',
        from_date:'',
        payment_status: 'unpaid',
        to_date: '',
        date_range:"",
        receivables:[],
        headers: [
            // { text: 'AR #', value: 'id' },
             { text: 'Invoice #', value: 'invoice' },
              { text: 'Ref. D.R', value: 'drnumber' },
              { text: 'Trade Name', value: 'trade_name' },
              { text: 'Salesman', value: 'salesman'},
              { text: 'Invoice Date', value: 'invoice_date' },
              { text: 'AMOUNT', value: 'amount', align:'right'}
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
            this.SET_MENUS()
         
          var current_date = this.$moment()
          var startdate = current_date.subtract(7, "days")
          this.from_date =  this.$moment(startdate).format("YYYY-MM-DD")
          this.to_date =  this.$moment().format("YYYY-MM-DD")
          this.getItems()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      salesEvent(){
        this.salesform = false
         this.getItems()
      },
      getItems() {
        this.$http.post("receivable/list",  {data: this.payment_status, from_date:this.from_date, to_date: this.to_date}).then(response => {
              response.data.items != null?this.receivables = response.data.items:this.receivables=[]
          }).catch(e => {
           console.log(e.data)
         })
      }
     
    }
  }
</script>